import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MOBILE_QUERY_MAX_WIDTH_M } from "constants/vp-sizes";
import Constants from "segments/desktop/header/layouts/components/basic-header/constants";
const HEADER_CONTENT_HORIZONTAL_PADDING = `${Constants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;
export const StyledIconWithParagraphGridComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;
  padding: 0 ${HEADER_CONTENT_HORIZONTAL_PADDING};

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH_M}) {
    padding: 8px;
  }
`;
